<span class="filter-tag">
    <span class="filter-tag-label">{{ label }}</span>
</span>